module.exports = __webpack_public_path__ + "static/media/lindafrietman.7c1227b9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/lindafrietman.webp
// module id = 590
// module chunks = 0